import { NgModule } from '@angular/core';

import { ShowForDirective } from './directives/show-for.directive';
import { HideForDirective } from './directives/hide-for.directive';

@NgModule({
  declarations: [
    ShowForDirective,
    HideForDirective,
  ],
  exports: [
    ShowForDirective,
    HideForDirective,
  ],
})
export class MediaControlModule {}
